export interface CalendarProps {}

export const Calendar = (props: CalendarProps): JSX.Element => (
  <>
    <div {...props}>TBD</div>
  </>
)

export default Calendar
